<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrMailTemplate from "@/models/StrMailTemplate";
export default {
  mixins: [Api, Sabit, StrMailTemplate],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      specialTags: [
        "[[BirimAdi]]",
        "[[Iyilesitirme]]",
        "[[Donem]]",
        "[[BitisAy]]",
        "[[BitisYil]]", 
        "[[Revizyonaciklama]]"
      ],
    };
  },
  components: {
    Loader,
    forminput,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("StrMailTemplate", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.StrMailTemplateData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrMailTemplate");
            }
          });
        } else {
          this.Update("StrMailTemplate", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrMailTemplateData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrMailTemplate");
            }
          });
        }
      }
    },
    Get() { },

    insertTag(tag) { 
      const textarea = this.$refs.messageTextarea;
 
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      this.FormData.Mesaj =
        this.FormData.Mesaj.slice(0, start) +
        tag +
        this.FormData.Mesaj.slice(end); 
      this.$nextTick(() => {
        textarea.setSelectionRange(start + tag.length, start + tag.length);
        textarea.focus();
      });
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrMailTemplate" size="lg" :title="this.AddEdit == 'Edit'
        ? 'Düzenle'
        : 'Yeni Kayıt Ekle'
      " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row">
          <forminput :FormDataType="FormDataType.Kod" :Value="FormData.Kod" :v="$v.FormData.Kod"
            @input="FormData.Kod = $event" />
          <forminput :FormDataType="FormDataType.Tanim" :Value="FormData.Tanim" :v="$v.FormData.Tanim"
            @input="FormData.Tanim = $event" />
          <forminput :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik" :v="$v.FormData.Baslik"
            @input="FormData.Baslik = $event" />
          <b-form-group class="col-lg-12" :label="FormDataType.Mesaj.FieldTitle">
            <textarea class="form-control w-100" v-model="FormData.Mesaj" style="min-height: 250px;"
              ref="messageTextarea"></textarea> 
            <div class="mt-3">
              <h5>Dinamik Etiketler:</h5>
              <div class="d-flex flex-wrap">
                <button type="button" v-for="tag in specialTags" :key="tag" class="btn btn-primary m-1"
                  @click="insertTag(tag)">
                  {{ tag }}
                </button>
              </div>
            </div> 
          </b-form-group> 
        </div>
        <button class="btn btn-success" type="submit">
          Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
